import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import PageTransition from "../components/PageTransition";
import MainLayout from "../components/layout/MainLayout";
import Loginpage from "../screens/Login/Loginpage";
import Home from "../screens/home/home";
import BookingPage from "../screens/mybookings/BookingPage";
import SlotsPage from "../screens/slots/slotspage";
import FacilityPage from "../screens/Facilities/FacilityPage";
import CreateSlotPage from "../screens/slots/createslotpage";
import AddFacilityPage from "../screens/Facilities/addfacilitypage";
import EditFacilityPage from "../screens/Facilities/editfacilitypage";
import PitchPage from "../screens/Facilities/PitchCourtPage";
import SchedulePage from "../screens/Schedule/SchedulePage";
import DashboardPage from "../screens/dashboard/dashboard";
import ViewFacilityPage from "../screens/Facilities/viewfacilitypage";
import EditProfile from "../components/profile/editprofile/editprofile";
import AccountSetting from "../screens/AccountSetting/AccountSetting";
import ContactUs from "../screens/ContactUs/ContactUs";
import MessagesPage from "../screens/Messages/MessagesPage";
import AnalyticsPage from "../screens/Analytics/AnalyticsPage";
import NotificationsPage from "../screens/Notifications/NotificationsPage";
import ProtectedRoute from "../components/ProtectedRoute";

const AppRoutes = () => {
  const location = useLocation();

  const renderWithTransition = (Component) => (
    <PageTransition key={location.pathname}>
      <Component />
    </PageTransition>
  );

  const renderProtectedRoute = (Component) => (
    <ProtectedRoute>
      {renderWithTransition(Component)}
    </ProtectedRoute>
  );

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={renderWithTransition(Loginpage)} />

      {/* Protected Routes with Layout */}
      <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={renderWithTransition(Home)} />
        <Route path="/Bookings" element={renderWithTransition(BookingPage)} />
        <Route path="/Slots" element={renderWithTransition(SlotsPage)} />
        <Route path="/Facilities" element={renderWithTransition(FacilityPage)} />
        <Route path="/createslots" element={renderWithTransition(CreateSlotPage)} />
        <Route path="/AddFacility" element={renderWithTransition(AddFacilityPage)} />
        <Route path="/edit-facility" element={renderWithTransition(EditFacilityPage)} />
        <Route path="/Pitch" element={renderWithTransition(PitchPage)} />
        <Route path="/Schedule" element={renderWithTransition(SchedulePage)} />
        <Route path="/Dashboard" element={renderWithTransition(DashboardPage)} />
        <Route path="/ViewFacility" element={renderWithTransition(ViewFacilityPage)} />
        <Route path="/Profile" element={renderWithTransition(EditProfile)} />
        <Route path="/AccountSettings" element={renderWithTransition(AccountSetting)} />
        <Route path="/Contactus" element={renderWithTransition(ContactUs)} />
        <Route path="/messages" element={renderWithTransition(MessagesPage)} />
        <Route path="/analytics" element={renderWithTransition(AnalyticsPage)} />
        <Route path="/notifications" element={renderWithTransition(NotificationsPage)} />
      </Route>

      {/* Catch all route - redirect to home */}
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
};

export default AppRoutes;
